import { Component, Input, Output, OnInit, EventEmitter, SimpleChanges } from '@angular/core';

import { BaseComponent } from '../../base.component';

import * as dayjs from 'dayjs';

@Component({
    selector: 'time-picker',
    templateUrl: './time-picker.component.html',
    styleUrls: ['./time-picker.component.scss']
})
export class TimePickerComponent extends BaseComponent implements OnInit {
    /** time */
    @Input() public time: number;
    /** Hour */
    public hour: number;
    /** Minute */
    public minute: string;
    /** Meridium */
    public meridium: string;
    /** Hours options for picker */
    public hours_options = [8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7];
    /** Minutes options for picker */
    public minutes_options: string[] = [];
    /** Meridium Options */
    public meridium_options = ['AM', 'PM'];
    /** Whether appointment is unscheduled */
    public is_unscheduled: boolean;
    /** Show unschedule option */
    @Input() public simple: boolean;
    /** event */
    @Output() public timeChange = new EventEmitter<number>();
    @Output() public event = new EventEmitter<string>();

    public ngOnInit(): void {
        this.loadMinutesOptions();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.time && this.time) {
            this.initTime();
        }
    }

    public initTime(): void {
        const time = dayjs(this.time);
        const roundedMinutes = Math.ceil(time.minute() / 5) * 5;
        this.time = dayjs(this.time).minute(roundedMinutes).valueOf();
        this.hour = dayjs(this.time).hour();
        this.meridium = dayjs(this.time).format('A');
        if (this.hour === 0) {
            this.hour = 12;
        } else if (this.hour > 12) {
            this.hour = this.hour - 12;
        }
        this.minute = dayjs(this.time).format('mm');
        this.timeout('scroll', () => this.scrollToSelectedTime());
    }

    /** load minutes */
    public loadMinutesOptions(): void {
        let time = dayjs().startOf('h');
        const end = dayjs().endOf('h');
        for(; time.isBefore(end); time = time.add(5,'m')) {
            this.minutes_options.push(time.format('mm'));
        }
    }

    public changeHour(hour: number): void {
        this.hour = hour;
    }

    public changeMinute(minute: string): void {
        this.minute = minute;
    }

    public changeMeridium(meridium: string): void {
        this.meridium = meridium;
    }

    public changeTime(): void {
        if (this.is_unscheduled) {
            this.time = null;
        } else {
            let hour_24;
            if (this.meridium === 'AM') {
                hour_24 = this.hour === 12 ? 0 : this.hour;
            } else {
                hour_24 = this.hour === 12 ? this.hour : this.hour + 12;
            }
            this.time = dayjs().hour(hour_24).minute(Number(this.minute)).valueOf();
        }
        this.timeChange.emit(this.time);
    }

    public scrollToSelectedTime(): void {
        document.getElementById('hour').scrollIntoView();
        document.getElementById('minute').scrollIntoView();
    }

    public close() {
        this.is_unscheduled = false;
        this.event.emit('close');
    }
}